/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getBookingsByTokenCartID } from "../../../actions/admin/booking";
import { useEffect } from "react";
import { useState } from "react";
import LanguageCard from "../../../components/layout-new-theme/LanguageCard";
import { getLocationByAddress } from "../../../actions/googleAPI";
import { useHistory } from "react-router-dom";
import { setLanguage } from "../../../actions/admin/settings";
import {
  flywireUpdatePayment,
  flywireAddPayment,
  setDefaultPayment,
  deletePayment,
  flywireUpdatePaymentAuthUser,
  flywireAddPaymentUser
} from "../../../actions/admin/flywire";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  AddIcon,
  RadioSelectedIcon,
  RadioUnselectedIcon,
  ThreeDotsIcon,
} from "../../../components/icons";


const visa_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/visa.svg";
const master_card_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/master-card.svg";
const jcb_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/jcb.svg";
const american_ex_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/american_ex.svg";
const logo_brand = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-brand.svg";
const logo_brand_name = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-brand-name.svg";
const ChangePaymentMethod = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { token } = useParams();
  const [authenticated, setAuthenticated] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [bookings, setBookings] = useState([]);
  const [cartId, setCartId] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  useEffect(() => {
    const closeDropdowns = (e) => {
      if (!e.target.closest("[data-dropdown]")) setOpenDropdown(null);
    };
    document.addEventListener("click", closeDropdowns);
    return () => document.removeEventListener("click", closeDropdowns);
  }, []);

  const history = useHistory();

  const { t } = useTranslation();

  const callbackFlywire = async (result, ref) => {
    result.ref = ref;

    if (result.status === "success") {
      const updatePayment = await flywireUpdatePayment(result);

      setLoading(false);
      if (
        updatePayment.status === 200 &&
        updatePayment.data.status === "SUCCESS"
      ) {
        history.push(`/success-change-payment-method`);
      }
    }
  };

  const callbackFlywireAddPaymentMethod = async (result, ref) => {
    result.ref = ref;

    if (result.status === "success") {
      const updatePayment = await flywireAddPaymentUser(result);

      setLoading(false);
      if (
        updatePayment.status === 200 &&
        updatePayment.data.status === "SUCCESS"
      ) {
        history.push(`/`);
      }
    }
  };

  const extractFirstAndLastName = async (fullName) => {
    // Split the full name into an array of strings
    const nameParts = fullName.trim().split(" ");

    // Extract the first name (first element of the array)
    const firstName = nameParts[0];

    // Extract the last name (last element of the array, if exists)
    const lastName =
      nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";

    // Return an object containing the first name and last name
    return {
      firstName: firstName,
      lastName: lastName ? lastName : firstName,
    };
  };

  const changePaymentMethodHandler = async () => {
    setLoading(true);

    const { firstName, lastName } = await extractFirstAndLastName(
      bookings[0].customer.name
    );
    const zipCodeCheck = await getLocationByAddress(
      bookings[0].customer.postal_code,
      bookings[0].customer.country_code
    );

    const config = {
      env: process.env.REACT_APP_FLYWIRE_ENV,
      recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

      // >0 for Seed Payment and Optional Tokenization; 0 for Zero-Value Tokenization;
      amount: 0,
      //Mandatory tokenization before payment - "tokenization" or "optional_tokenization";
      recurringType: "tokenization",
      recurringTypeRecipientCodes: [
        process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
        process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE,
      ],

      // Specify the returnUrl or an onCompleteCallback handler
      // returnUrl: process.env.REACT_APP_URL + "/PaymentSuccess/"+ cart_id,

      // Other checkout parameters (e.g. pass payer info or set requestPayerInfo to true)
      firstName: firstName,
      lastName: lastName,
      email: bookings[0].customer.email,
      phone:
        bookings[0].customer.prefix_number + " " + bookings[0].customer.phone,
      address: bookings[0].customer.address,
      city: zipCodeCheck.address_components.filter(
        (item) =>
          item.types.includes("administrative_area_level_2") ||
          item.types.includes("locality")
      )[0].long_name,
      zip: bookings[0].customer.postal_code,
      country: bookings[0].customer.country_code,

      recipientFields: {
        booking_reference: `CB-${cartId}`,
        additional_information: null,
      },

      requestPayerInfo: false,
      requestRecipientInfo: false,

      // Control which tokenization options are available
      paymentOptionsConfig: {
        filters: {
          type: ["credit_card"],
        },
      },
      onCompleteCallback: function (args) {
        callbackFlywire(args, `CB-${cartId}`);
      },
      onInvalidInput: function (errors) {
        errors.forEach(function (error) {
          console.log(error.msg);
        });
      },
    };

    setLoading(false);
    const modal = window.FlywirePayment.initiate(config);
    modal.render();
  };

  const updatePaymentAuthenticatedUserHandler = async () => {
    const updatePayment = await flywireUpdatePaymentAuthUser(token, selectedPayment);

    setLoading(false);
    if (
      updatePayment.status === 200 &&
      updatePayment.data.status === "PAYMENT_HAS_NOT_BEEN_CHANGED"
    ) {
      window.scrollTo(0, 0)
    } else if (
      updatePayment.status === 200 &&
      updatePayment.data.status === "SUCCESS"
    ) {
      history.push(`/`);
    }
  }

  const addPaymentMethodHandler = async () => {
    setLoading(true);

    const { firstName, lastName } = await extractFirstAndLastName(
      bookings[0].customer.name
    );
    const zipCodeCheck = await getLocationByAddress(
      bookings[0].customer.postal_code,
      bookings[0].customer.country_code
    );

    const config = {
      env: process.env.REACT_APP_FLYWIRE_ENV,
      recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

      // >0 for Seed Payment and Optional Tokenization; 0 for Zero-Value Tokenization;
      amount: 0,
      //Mandatory tokenization before payment - "tokenization" or "optional_tokenization";
      recurringType: "tokenization",
      recurringTypeRecipientCodes: [
        process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
        process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE,
      ],

      // Specify the returnUrl or an onCompleteCallback handler
      // returnUrl: process.env.REACT_APP_URL + "/PaymentSuccess/"+ cart_id,

      // Other checkout parameters (e.g. pass payer info or set requestPayerInfo to true)
      firstName: firstName,
      lastName: lastName,
      email: bookings[0].customer.email,
      phone: bookings[0].customer.prefix_number + " " + bookings[0].customer.phone,
      address: bookings[0].customer.address,
      city: zipCodeCheck.address_components.filter(
        (item) =>
          item.types.includes("administrative_area_level_2") ||
          item.types.includes("locality")
      )[0].long_name,
      zip: bookings[0].customer.postal_code,
      country: bookings[0].customer.country_code,

      recipientFields: {
        booking_reference: `CB-${cartId}`,
        additional_information: null,
      },

      requestPayerInfo: false,
      requestRecipientInfo: false,

      // Control which tokenization options are available
      paymentOptionsConfig: {
        filters: {
          type: ["credit_card"],
        },
      },
      onCompleteCallback: function (args) {
        callbackFlywireAddPaymentMethod(args, `CB-${cartId}`);
      },
      onInvalidInput: function (errors) {
        errors.forEach(function (error) {
          console.log(error.msg);
        });
      },
    };

    setLoading(false);
    const modal = window.FlywirePayment.initiate(config);
    modal.render();
  };

  const setDefaultPaymentHandler = async (paymentId) => {
    const updatePayment = await setDefaultPayment(token, paymentId);

    setLoading(false);
    if (
      updatePayment.status === 200
    ) {
      setBookings(updatePayment.data);
    }
  }

  const deletePaymentHandler = async (paymentId) => {
    const updatePayment = await deletePayment(token, paymentId);

    setLoading(false);
    if (
      updatePayment.status === 200
    ) {
      setBookings(updatePayment.data);
    }
  }

  const getCardTypeByBrand = (type) => {
    if (type === "VISA") {
      return visa_icon;
    } else if (type === "MASTERCARD") {
      return master_card_icon;
    } else if (type === "AMERICAN EXPRESS") {
      return american_ex_icon;
    } else if (type === "JCB") {
      return jcb_icon;
    }
    return "Unknown";
  };

  const handleGetBookingsByTokenCartID = async (token) => {
    try {
      setError("");
      setLoading(true);
      const response = await getBookingsByTokenCartID(token);
      if (response.length === 0) {
        setError("No booking found for this cart");
      } else if (!response[0].hasOwnProperty("flywireResponse")) {
        setError("No flywire payment method found for this");
        // } else if (response[0].paymentStatus !== "CHARGE_PENDING") {
        //   setError("Page unavailable");
      } else if (response[0].paymentMethodStatus === "CHANGED") {
        setError("Page unavailable");
      } else {
        setCartId(response[0].cartID);
        setBookings(response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetBookingsByTokenCartID(token);
  }, [token]);

  useEffect(() => {
    try {
      if (localStorage.getItem("lang") === undefined || localStorage.getItem("lang") === null) {
        var userLang = navigator.language || navigator.userLanguage;
        if (userLang === "ja") {
          langChange("JP");
        } else {
          langChange("EN");
        }
      } else {
        langChange(localStorage.getItem("lang"));
      }
    } catch {
      console.log("error")
    }
  }, []);

  const langChange = (lng) => {
    i18n.changeLanguage(lng.toLowerCase());
    localStorage.setItem("lang", lng);
    dispatch(setLanguage(lng));
  };

  const getTotalPrice = () => {
    if (bookings?.fromQuotation) {
      if (bookings?.quotation?.useDiscount) {
        return bookings?.discountedPrice;
      } else {
        return bookings?.totalPrice
      }
    } else {
      return bookings?.totalPrice
    }
  }

  if (loading) {
    return (
      <div className="tw:flex tw:justify-center tw:items-center tw:h-screen">
        <div className="tw:inline-block tw:w-8 tw:h-8 tw:align-[-0.125em] tw:border-4 tw:border-current tw:border-r-transparent tw:rounded-full tw:animate-spin tw:text-[#0d6efd]!" role="status">
          <span className="tw:sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tw:flex tw:justify-center tw:items-center tw:h-screen">
        <h1>{error}</h1>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: "#F6F6F6" }}>
      {/* Navbar */}

      <nav className="tw:relative tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:py-2 tw:sm:flex-nowrap tw:sm:justify-start tw:bg-[#212529]  tw:sticky tw:top-0 tw:z-[1020]">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)]">
          <div className="tw:block! tw:md:hidden!"></div>
          <img
            alt=""
            src={logo_brand}
            style={{ width: "70px", marginLeft: "100px" }}
            className="tw:py-[0.3125rem] tw:mr-4 tw:whitespace-nowrap tw:block! tw:md:hidden!"
          />
          <img
            alt=""
            src={logo_brand_name}
            style={{ width: "70px" }}
            className="tw:py-[0.3125rem] tw:mr-4 tw:whitespace-nowrap tw:hidden! tw:md:block!"
          />
          <LanguageCard />
        </div>
      </nav>
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:mt-12">
        <p className="fs-22 tw:text-[#212529]! fw-700 noto">
          {t("ChangePaymentMethod.Title")}
        </p>
        <div className="tw:bg-white tw:rounded-[0.375rem] tw:mt-4 tw:p-4">
          <p
            className="text-4E4E4E"
            dangerouslySetInnerHTML={{
              __html: t("ChangePaymentMethod.Desc"),
            }}
          ></p>
          <p className="text-4E4E4E">{t("ChangePaymentMethod.Desc2")}</p>
          <div className="registered-card tw:mb-4">
            {/* <p className="tw:mt-4 fw-700 noto-sans">
              {t("ChangePaymentMethod.RegisteredCard")}
            </p> */}

            {bookings[0].customer.userId && (
              <>
                {
                  bookings[0].customer.userId.individualDetail.paymentMethod.map((v, ind) => {
                    return (v.brand !== bookings[0].flywireResponse.brand || v.cardNumber !== bookings[0].flywireResponse.digits) ? (
                      <div
                        className="tw:rounded-[0.375rem] border-bottom-gold tw:p-2 tw:mb-4 pointer"
                        onClick={() => {
                          setSelectedPayment(v.token)
                        }}
                      >
                        <div className="tw:flex tw:justify-between tw:items-center">
                          <div className="tw:flex tw:items-center tw:gap-2 tw:py-1">
                            {selectedPayment === v.token ? (
                              <RadioSelectedIcon className="tw:ml-2" />
                            ) : (
                              <RadioUnselectedIcon className="tw:ml-2" />
                            )}
                            <img
                              src={getCardTypeByBrand(
                                v.brand
                              )}
                              alt=""
                              srcSet=""
                              height={13}
                            />
                            <p className="tw:m-0">
                              •••• {v.cardNumber}, Exp.:{" "}
                              {v.expirationMonth}/
                              {v.expirationYear}
                            </p>
                            {
                              v.isActive && (
                                <p className="tw:ml-2 bg-gold tw:rounded-[0.375rem] tw:text-white! tw:m-0 fs-10 tw:px-2 tw:py-1">
                                  Default
                                </p>
                              )
                            }
                          </div>
                          <div className="tw:relative" data-dropdown>
                            <button
                              className="no-dropdown-toggle tw:bg-transparent tw:border-0 tw:cursor-pointer"
                              type="button"
                              onClick={(e) => { e.stopPropagation(); setOpenDropdown(openDropdown === ind ? null : ind); }}
                              aria-expanded={openDropdown === ind}
                            >
                              <ThreeDotsIcon className="tw:mr-2" />
                            </button>
                            <ul className={`tw:absolute tw:z-[1000] tw:min-w-[10rem] tw:py-2 tw:m-0 tw:text-base tw:text-[#212529] tw:text-left tw:list-none tw:bg-white tw:bg-clip-padding tw:border tw:border-[rgba(0,0,0,0.15)] tw:rounded-[0.375rem] tw:shadow-[0_0.5rem_1rem_rgba(0,0,0,0.175)] tw:right-0 tw:top-full ${openDropdown === ind ? "tw:block!" : "tw:hidden!"}`} onClick={(e) => { e.stopPropagation(); setOpenDropdown(null); }}>
                              <li>
                                <a className="tw:block! tw:w-full tw:py-1 tw:px-4 tw:font-normal tw:text-[#212529] tw:whitespace-nowrap tw:no-underline tw:hover:bg-[#e9ecef] tw:cursor-pointer"
                                  onClick={() => setDefaultPaymentHandler(v._id)}>
                                  {t("ChangePaymentMethod.SetAsDefault")}
                                </a>
                              </li>
                              <li>
                                <a className="tw:block! tw:w-full tw:py-1 tw:px-4 tw:font-normal tw:text-[#212529] tw:whitespace-nowrap tw:no-underline tw:hover:bg-[#e9ecef] tw:cursor-pointer"
                                  onClick={() => deletePaymentHandler(v._id)}>
                                  {t("ChangePaymentMethod.DeleteCard")}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ) : ""
                  })
                }

                <div className="tw:grid tw:md:block!">
                  <button
                    className="border-gold tw:py-4 tw:md:py-4 tw:px-12 text-4E4E4E fw-400 tw:rounded-[0.375rem] fs-14 noto-sans"
                    onClick={() => addPaymentMethodHandler()}
                  >
                    <div className="tw:flex tw:mx-4 tw:justify-center">
                      <AddIcon />
                      <span className="tw:ml-2">
                        {t("ChangePaymentMethod.AddPaymentMethod")}
                      </span>
                    </div>
                  </button>
                </div>
              </>
            )}
          </div>
          <div className="tw:grid tw:md:block!">
            {/* <button
              className="bg-gold-light-100 tw:py-4 tw:md:py-4 tw:px-12 text-4E4E4E fw-400 tw:rounded-[0.375rem] fs-14 noto-sans"
              onClick={() => {
                if(bookings[0].customer.userId){
                  updatePaymentAuthenticatedUserHandler()
                }else{
                  changePaymentMethodHandler()
                }
              }}
            >
              <span className="tw:px-12">
                {t("ChangePaymentMethod.UpdatePaymentMethod")}
              </span>
            </button> */}
          </div>
        </div>
        <div className="tw:mt-4">
          <p className="fs-16 tw:text-[#212529]! fw-700 noto">
            {t("ChangePaymentMethod.ReservationDetails")}
          </p>
          <div className="tw:mt-4 tw:bg-white tw:rounded-[0.375rem]">
            <div className="tw:flex tw:justify-between tw:p-6">
              <p className="text-4E4E4E fw-700 fs-16 noto tw:m-0">Total</p>
              <p className="text-4E4E4E fw-700 fs-16 noto tw:m-0">
                JPY{" "}
                {bookings
                  .reduce((acc, obj) => acc + obj.totalPrice, 0)
                  .toLocaleString()}
              </p>
            </div>
            <hr className="tw:m-0 hr-D9D9D9" />
            {bookings.map((booking, i = 0) => (
              <div className="booking-item">
                <div className="tw:p-6">
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                      <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                        {t("my_page.bookings_page.booking_item.booking_id")}
                      </p>
                      <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                        #{booking.key}
                      </p>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                      <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                        {t("my_page.bookings_page.booking_item.passenger_name")}
                      </p>
                      <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                        {booking?.passengerName}
                      </p>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                      <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                        {t(
                          "my_page.bookings_page.booking_item.type_of_transfer"
                        )}
                      </p>
                      <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                        {booking?.bookingType === "byTheHour"
                          ? t("my_page.bookings_page.booking_item.by_the_hour")
                          : booking?.isAirportTransfer
                            ? t(
                              "my_page.bookings_page.booking_item.airport_transfer"
                            )
                            : t(
                              "my_page.bookings_page.booking_item.specific_destination"
                            )}
                      </p>
                    </div>
                  </div>
                  <hr className="tw:m-0 hr-F4F4F4" />
                  <div className="tw:hidden! tw:md:block!">
                    {/* Desktop view */}
                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-4">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                        <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                          {t("my_page.bookings_page.booking_item.pickup_time")}
                        </p>
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {moment(booking?.travelDate).format(
                            "MMM. Do, YYYY (ddd)"
                          )}
                          , {booking.pickupTime}
                        </p>
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-3/4 tw:md:flex-none">
                        <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                          {t(
                            "my_page.bookings_page.booking_item.pick_up_location"
                          )}
                        </p>
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {booking.pickupLocation?.label}
                        </p>
                      </div>
                    </div>
                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                        <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                          {t(
                            "my_page.bookings_page.booking_item.estimated_drop_off_time"
                          )}
                        </p>
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {moment(booking?.customerDropoffDateTime).format(
                            "MMM. Do, YYYY (ddd), HH:mm"
                          )}
                        </p>
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-3/4 tw:md:flex-none">
                        <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                          {t(
                            "my_page.bookings_page.booking_item.drop_off_location"
                          )}
                        </p>
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {booking?.destinations.map((item, index) => {
                            return (
                              <>
                                {item.label}
                                {index === booking.destinations.length - 1 ? (
                                  ""
                                ) : (
                                  <br />
                                )}
                              </>
                            );
                          })}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="tw:block! tw:md:hidden!">
                    {/* Mobile view */}
                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mt-4">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                        <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                          {t("my_page.bookings_page.booking_item.pickup_time")}
                        </p>
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {moment(booking?.travelDate).format(
                            "MMM. Do, YYYY (ddd)"
                          )}
                          , {booking.pickupTime}
                        </p>
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                        <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                          {t(
                            "my_page.bookings_page.booking_item.estimated_drop_off_time"
                          )}
                        </p>
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {moment(booking?.customerDropoffDateTime).format(
                            "MMM. Do, YYYY (ddd), HH:mm"
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                        <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                          {t(
                            "my_page.bookings_page.booking_item.pick_up_location"
                          )}
                        </p>
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {booking.pickupLocation?.label}
                        </p>
                      </div>
                      <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                        <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                          {t(
                            "my_page.bookings_page.booking_item.drop_off_location"
                          )}
                        </p>
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {booking?.destinations.map((item, index) => {
                            return (
                              <>
                                {item.label}
                                {index === booking.destinations.length - 1 ? (
                                  ""
                                ) : (
                                  <br />
                                )}
                              </>
                            );
                          })}
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr className="tw:mt-4 hr-F4F4F4" />
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                      <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                        {t("Vehicle")}
                      </p>
                      <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                        {booking.bookingInfo.map((item, index) => {
                          return (
                            <>
                              {item.vehicleTypeName}
                              {index === booking.bookingInfo.length - 1
                                ? ""
                                : ", "}
                            </>
                          );
                        })}
                      </p>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                      <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                        {t("my_page.bookings_page.booking_item.passenger")}
                      </p>
                      <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                        {booking.bookingInfo.map((item, index) => {
                          return item.pax
                            .filter((passenger) => passenger.paxcount > 0)
                            .map((passenger, index, array) => (
                              <span key={passenger.paxtype}>
                                {t(
                                  `my_page.bookings_page.booking_item.${passenger.paxtype}`
                                )}
                                : {passenger.paxcount}
                                {index !== array.length - 1 ? ", " : ""}
                              </span>
                            ));
                        })}
                      </p>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                      <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                        {t("my_page.bookings_page.booking_item.luggage")}
                      </p>
                      <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                        {booking.bookingInfo.map((item, index) => {
                          return item.luggage
                            .filter((luggage) => luggage.luggagecount > 0)
                            .map((luggage, index, array) => (
                              <span key={luggage.luggagetype}>
                                {luggage.luggagetype === "CHECK-IN SIZE"
                                  ? t(
                                    "my_page.bookings_page.booking_item.check_in"
                                  )
                                  : t(
                                    "my_page.bookings_page.booking_item.cabin"
                                  )}
                                : {luggage.luggagecount}
                                {index !== array.length - 1 ? ", " : ""}
                              </span>
                            ));
                        })}
                      </p>
                    </div>
                  </div>
                  <hr className="tw:mt-4 hr-F4F4F4" />
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                      <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                        {t("my_page.bookings_page.booking_item.add_on_service")}
                      </p>
                      {booking.meetAssist != null &&
                        (booking?.meetAssist[0].meetAssistName !== "none" ||
                          booking?.meetAssist[1].meetAssistName !== "none") && (
                          <div>
                            <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                              {t(
                                "my_page.bookings_page.booking_item.airport_meet_assist"
                              ) +
                                "(" +
                                (booking?.meetAssist[0].meetAssistName !==
                                  "none" &&
                                  booking?.meetAssist[1].meetAssistName !== "none"
                                  ? t("my_page.bookings_page.booking_item.both")
                                  : "ok") +
                                ")"}
                            </p>
                            <br />
                          </div>
                        )}
                      {booking.bookingInfo[0].travelArea &&
                        booking.bookingType === "byTheHour" &&
                        booking.bookingInfo[0].travelArea !== "" && (
                          <div>
                            <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                              {`${t(
                                "NewCart.AddOnServices.TravelArea.Title"
                              )} ${t(
                                "NewCart.AddOnServices.TravelArea." +
                                booking.bookingInfo[0].travelArea
                              )}`}
                            </p>
                            <br />
                          </div>
                        )}
                      {booking.childSeatPrice > 0 ? (
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {t("my_page.bookings_page.booking_item.child_seat")} x{" "}
                          {booking.bookingInfo.reduce(
                            (sum, booking) =>
                              sum +
                              booking.infantSizeSeat +
                              booking.toddlerSizeSeat +
                              booking.childSizeSeat,
                            0
                          )}
                        </p>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/4 tw:md:flex-none">
                      <p className="fw-700 fs-11 noto-sans text-A7A7A7 tw:mb-1">
                        {t(
                          "my_page.bookings_page.booking_item.additional_information"
                        )}
                      </p>
                      {booking?.pickupFlightNo == null &&
                        booking?.dropoffFlightNo == null && (
                          <p className="to-be-assigned">
                            {t("my_page.bookings_page.booking_item.none")}
                          </p>
                        )}
                      {booking?.pickupFlightNo !== null && (
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {t(
                            "my_page.bookings_page.booking_item.arrival_flight_number"
                          )}
                          {booking?.pickupFlightNo}
                          <br />{" "}
                        </p>
                      )}
                      {booking?.dropoffFlightNo !== null && (
                        <p className="fw-700 fs-14 noto-sans text-4E4E4E">
                          {t(
                            "my_page.bookings_page.booking_item.depature_flight_number"
                          )}
                          {booking?.dropoffFlightNo}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bg-gold-light-100 border-bottom-DBBE78">
                  <div className="tw:py-4 tw:px-6">
                    <div className="tw:flex tw:justify-between">
                      <p className="tw:m-0 fw-400 fs-14 noto-sans text-282828">
                        {t("my_page.bookings_page.booking_item.price")}
                      </p>
                      <p className="tw:m-0 fw-700 fs-14 noto-sans text-282828">
                        JPY {booking.totalPrice.toLocaleString()}sss
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="tw:pb-12"></div>
    </div>
  );
};

export default ChangePaymentMethod;
